module.exports = __webpack_public_path__ + "img/main_cn4.fa732783.svg";